import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-CgjIzafk.js';

const listItemDividerCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.5rem 0}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiListItemDivider = /*@__PURE__*/ proxyCustomElement(class WuiListItemDivider extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '1da797574a1196e8675b0555392a64606be34637' }, h("wui-divider", { key: '76750be7917f203a8d45c8ea5c988c26c0b7a4fa' })));
    }
    static get style() { return listItemDividerCss; }
}, [257, "wui-list-item-divider"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-divider", "wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemDivider);
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemDivider as W, defineCustomElement as d };
